import { useContext } from 'react';

import { LoadingContext, LoadingContextValue } from '../providers/loading/LoadingContext';

/**
 * Hook to access loading context
 * @throws Error if used outside LoadingProvider
 */
export const useLoading = (): LoadingContextValue => {
  const context = useContext(LoadingContext);
  if (context === undefined) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

/**
 * Alias for backward compatibility
 * @deprecated Use useLoading instead
 */
export const useLoadingContext = useLoading;
